import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import { Buffer } from "buffer";
import QRCode from "qrcode";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import { API, AppData } from "./api";

type QRCodeType = "TimeCard10" | "SchmerIT";
type QRCodeImage = {
  name: string;
  data: string;
};
type QRCodePayload = {
  type: QRCodeType;
  metadata: any;
};
const imageSize = 256;

const printDiv = (elem: HTMLElement) => {
  const innerHTML = elem.innerHTML;
  const fullHTML = `<html>
    <head>
      <title>QR Codes</title>
      <style>body { height:100vh;
       width:100vw;
       text-align:center;
       display:flex;
       flex-direction:column;
       align-items:center;
       justify-content:center;
       margin:0;
       padding:15px;
       color:#000;
       font-family:Arial; }
       div.qr-code-wrapper{margin:25px 0;border:1px solid #000;}
       div.qr-code-wrapper h2{margin:0 0 15px;border-bottom:1px solid #000;}</style>
    </head>
    <body>${innerHTML}</body>
    </html>`;
  const w = window.open("", "_blank");
  w!.document.documentElement.innerHTML = fullHTML;
  setTimeout(() => {
    w?.print();
  }, 100);
};

function App() {
  // const [api, setApi] = useState<API>(new API({
  //   server: 'https://timecard10.schmer.it',
  //   username: 'f.heinrich',
  //   password: 'F.Heinrich1'
  // }));
  // const [appData, setAppData] = useState<AppData>();
  const [qrCodeType, setQRCodeType] = useState<QRCodeType>("TimeCard10");
  const [qrCodeImages, setQrCodeImages] = useState<QRCodeImage[]>([]);
  const [apiToken, setApiToken] = useState<string>("");
  const [bookingType, setBookingType] = useState<number>(0);
  const [projectId, setProjectId] = useState<number>();
  const [workOperationId, setWorkOperationId] = useState<number>();
  const [comment, setComment] = useState<string>();
  const [isValid, setIsValid] = useState<boolean>();

  const elemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (qrCodeType === "TimeCard10")
      setIsValid(!!projectId && !!workOperationId);
    else if (qrCodeType === "SchmerIT")
      setIsValid(apiToken.length === 36);
  }, [qrCodeType, apiToken, projectId, workOperationId, comment]);

  // useEffect(() => {
  //   api.fetchData()
  //     .then(res => setAppData(res))
  //     .catch(err => {
  //       alert("Fehler beim Laden der Daten von TimeCard10. Bitte überprüfen Sie Ihre Einstellungen.")
  //     });
  // }, []);

  useEffect(() => {
    console.log(qrCodeImages);
  }, [qrCodeImages]);

  const createQRCode = async (name: string, dataJson: any) => {
    const dataJsonString = JSON.stringify(dataJson);
    const dataString = Buffer.from(dataJsonString).toString("base64");

    return new Promise<QRCodeImage>((resolve, reject) => {
      QRCode.toDataURL(
        dataString,
        {
          width: imageSize,
        },
        (error, res) => {
          if (error)
            reject("Fehler beim Erstellen des QR Codes: " + error.message);
          else
            resolve({
              name: name,
              data: res,
            });
        }
      );
    });
  };

  const createAPITokenInfo = async () => {
    const dataJson = {
      type: qrCodeType,
      metadata: {
        ApiToken: apiToken
      },
    };
    return createQRCode("API Token", dataJson);
  };

  const createBookingInfo = async (name: string, type: number) => {
    const dataJson = {
      type: "TimeCard10",
      metadata: {
        BookingType: type,
        ProjectId: projectId,
        WorkOperationId: workOperationId,
        Comment: comment,
      },
    };

    return createQRCode(name, dataJson);
  };

  const generate = async () => {
    if (!isValid) return;

    try {
      if (qrCodeType === "TimeCard10") {
        if (bookingType === 0) {
          setQrCodeImages([
            await createBookingInfo("Kommen", 4),
            await createBookingInfo("Gehen", 5),
          ]);
        } else {
          const name = bookingType === 4 ? "Kommen" : "Gehen";
          setQrCodeImages([await createBookingInfo(name, bookingType!)]);
        }  
      } else if (qrCodeType === "SchmerIT") {
        setQrCodeImages([
          await createAPITokenInfo()
        ]);
      }
    } catch (err: any) {
      alert(err?.message ?? err);
    }
  };

  return (
    <>
      <div className="header">
        <img src="logo_timecard10.png" alt="timeCard10" />
        <span>QR Code Generator für die TimeCard10 QR-Code Zeiterfassung</span>
        <a href="https://schmer.it" target="_blank">
          <img src="logo_poweredby.png" alt="powered by Schmer.IT GmbH" />
        </a>
      </div>
      <main>
        <div className="container">
          <h2>Eingaben</h2>
          <div className="content">
            <Form>
              <Form.Group className="mb-3" controlId="form.qrCodeType">
              <Form.Select
                  value={qrCodeType}
                  onChange={(ev) => setQRCodeType(ev.target.value as QRCodeType)}
                >
                  <option value="TimeCard10">Zeiterfassung</option>
                  <option value="SchmerIT">API Token</option>
                </Form.Select>
              </Form.Group>
              {qrCodeType === "SchmerIT" &&
              <>
                <Form.Group className="mb-3" controlId="form.apiToken>">
                  <Form.Label>API Token:</Form.Label>
                  <Form.Control as="input"
                    type="text"
                    minLength={36}
                    maxLength={36}
                    value={apiToken}
                    onChange={(ev) => setApiToken(ev.target.value)}
                  ></Form.Control>
                </Form.Group>
              </>
              }
              {qrCodeType === "TimeCard10" &&
              <>
                <Form.Group className="mb-3" controlId="form.bookingType">
                  <Form.Label>Art:</Form.Label>
                  <Form.Select
                    value={bookingType}
                    onChange={(ev) => setBookingType(parseInt(ev.target.value))}
                  >
                    <option value="0">Kommen + Gehen</option>
                    <option value="4">Kommen</option>
                    <option value="5">Gehen</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3" controlId="form.projectId">
                  <Form.Label>Projekt Id:</Form.Label>
                  <Form.Control as="input"
                    type="number"
                    min="0"
                    max="9999999"
                    step="1"
                    value={projectId}
                    onChange={(ev) => setProjectId(parseInt(ev.target.value))}
                  ></Form.Control>
                </Form.Group>
                <Form.Group className="mb-3" controlId="form.workOperationId">
                  <Form.Label>Tätigkeit Id:</Form.Label>
                  <Form.Control as="input"
                    type="number"
                    min="0"
                    max="9999999"
                    step="1"
                    value={workOperationId}
                    onChange={(ev) => setWorkOperationId(parseInt(ev.target.value))}
                  ></Form.Control>
                </Form.Group>
                <Form.Group className="mb-3" controlId="form.comment">
                  <Form.Label>Kommentar:</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={comment}
                    onChange={(ev) => setComment(ev.target.value)}
                  ></Form.Control>
                </Form.Group>
              </>
              }
            </Form>
          </div>
          {isValid && <Button onClick={generate}>Generieren</Button>}
        </div>
        {qrCodeImages?.length > 0 && (
          <>
            <div className="container" ref={elemRef}>
              {qrCodeImages.map((i, index) => (
                <div key={index} className="qr-code-wrapper">
                  <h2>QR Code "{i.name}"</h2>
                  <div className="qr-code">
                    <img alt="qrcode" width={imageSize} src={i.data} />
                  </div>
                </div>
              ))}
            </div>
            <div className="container">
              <Button onClick={() => printDiv(elemRef.current!)}>Drucken</Button>
            </div>
          </>
        )}
      </main>
    </>
  );
}

export default App;
